export const Reports: {INVOICE_REPORT: string;  CUSTOMER_REPORT:string; EXPENSE_REPORT: string; INVENTORY_REPORT: string } = {
    INVOICE_REPORT: "Invoice-Report",
    CUSTOMER_REPORT: "Customer-Report",
    EXPENSE_REPORT: "Expense-Report",
    INVENTORY_REPORT: "Inventory-Report"
  };